import React, { Fragment, useEffect, useState } from 'react'
import {
  Col,
  Row,
  Table,
  Label,
  Input,
  CardBody,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody
} from 'reactstrap'
import Select from 'react-select'
import Modal from 'react-bootstrap/Modal'
import { Link } from 'react-router-dom'
// removed react-csv usage; manual CSV download is used instead
import { API_URL } from './utils/Constants/URLS'
import 'primereact/resources/themes/lara-light-cyan/theme.css'
import { useDispatch, useSelector } from 'react-redux'
import '../css/OrgContacts.css'
import '../css/common.css'
import { addDeals } from './utils/redux/dealsSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faDownload,
  faList,
  faPenToSquare,
  faPlus
} from '@fortawesome/free-solid-svg-icons'
import PageHeader from './utils/PageHeader'
import PageLoader from './utils/PageLoader'

const ViewLeads = () => {
  const token = localStorage.getItem('token')
  const [showFilterCanvas, setShowFilterCanvas] = useState(false)
  const [searchLead, setSearchLead] = useState('')
  const [businessLineList, setBusinessLineList] = useState([])
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [clientDetails, setClientDetails] = useState([])
  const [ownerDetails, setOwnerDetails] = useState([])
  const [newExeId, setNewExeId] = useState('')
  const [changeLeadOwnerModal, setChangeLeadOwnerModal] = useState(false)
  const [changeLeadNameModal, setChangeLeadNameModal] = useState(false) // NEW modal state
  const [leadId, setLeadId] = useState('')
  const [clientId, setClientId] = useState('') //for filters
  const [leadOwner, setLeadOwner] = useState('') //for filters
  const [leadJourneyName, setLeadJourneyName] = useState('') // NEW state (you already mentioned)
  const [businessLineId, setBusinessLineId] = useState([]) //for filters
  const [leadStage, setLeadStage] = useState([]) //for filters
  const [leadList, setLeadList] = useState([])
  const [totalPages, setTotalPages] = useState(1)
  const [pageNumber, setPageNumber] = useState(1)
  const [nextPage, setNextPage] = useState(null)
  const [prevPage, setPrevPage] = useState(null)
  const [pageLoader, setPageLoader] = useState('')
  const [reportData, setReportData] = useState([]) // we keep this if you want to preview or re-download without refetching
  const dispatch = useDispatch()
  const userDetails = useSelector(store => store.user)
  const addDealToRedux = deal => {
    dispatch(addDeals(deal))
  }

  const closeFilterCanvas = () => {
    setShowFilterCanvas(false)
  }

  const handleAssignLead = lead_id => {
    setLeadId(lead_id)
    setChangeLeadOwnerModal(true)
  }

  const updateLeadJourneyName = async e => {
    e.preventDefault()
    try {
      const res = await fetch(`${API_URL}leads/${leadId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'Application/Json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          leadJourneyName
        })
      })
      const result = await res.json()
      if (result.error === false) {
        setLeadList(prev =>
          prev.map(item =>
            item.id === leadId ? { ...item, leadJourneyName } : item
          )
        )

        setChangeLeadNameModal(false)
        setShowSuccessModal(true)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const updateLeadOwner = async e => {
    e.preventDefault()
    try {
      const res = await fetch(`${API_URL}leads/${leadId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'Application/Json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          leadOwner: newExeId
        })
      })
      const result = await res.json()
      if (result.error === false) {
        setChangeLeadOwnerModal(false)
        setShowSuccessModal(true)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const handleFilteredBusinessLine = event => {
    const { value, checked } = event.target

    if (checked) {
      // Add the value to the state if the checkbox is checked
      setBusinessLineId(prevValues => [...prevValues, value])
    } else {
      // Remove the value from the state if the checkbox is unchecked
      setBusinessLineId(prevValues => prevValues.filter(v => v !== value))
    }
  }

  const handleFilteredStage = event => {
    const { value, checked } = event.target

    if (checked) {
      // Add the value to the state if the checkbox is checked
      setLeadStage(prevValues => [...prevValues, value])
    } else {
      // Remove the value from the state if the checkbox is unchecked
      setLeadStage(prevValues => prevValues.filter(v => v !== value))
    }
  }

  useEffect(() => {
    const fetchLead = async () => {
      setPageLoader(true)
      try {
        const url = `${API_URL}leads?limit=60&page=${pageNumber}${searchLead === '' ? '' : '&search=' + searchLead
          }${clientId === '' ? '' : '&client=' + clientId}${businessLineId.length === 0
            ? ''
            : '&businessLine=' + businessLineId.join(',')
          }${leadStage.length === 0 ? '' : '&status=' + leadStage.join(',')}&${leadOwner === '' ? '' : 'leadOwner=' + leadOwner
          }`
        const res = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'Application/Json',
            Authorization: `Bearer ${token}`
          }
        })
        const response = await res.json()
        setLeadList(response?.data?.docs)
        setTotalPages(response?.data?.totalPages)
        setNextPage(response?.data?.nextPage)
        setPrevPage(response?.data?.prevPage)
      } catch (e) {
        console.log(e)
      } finally {
        setPageLoader(false)
      }
    }

    fetchLead()
  }, [
    token,
    searchLead,
    pageNumber,
    clientId,
    businessLineId,
    leadStage,
    leadOwner
  ])

  useEffect(() => {
    const fetchClients = async () => {
      const url = `${API_URL}clients?pagination=false`
      const res = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'Application/Json',
          Authorization: `Bearer ${token}`
        }
      })
      const response = await res.json()
      setClientDetails(
        response?.data?.docs?.map(item => ({
          value: item?.id,
          label: item?.companyName
        }))
      )
    }
    fetchClients()
  }, [token])

  useEffect(() => {
    const fetchUser = async () => {
      const url = `${API_URL}users/org-contacts?pagination=false&search=executive${userDetails?.role === 'manager' ? `&businessLine=${userDetails?.businessLine}` : ''}`
      const res = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'Application/Json',
          Authorization: `Bearer ${token}`
        }
      })
      const response = await res.json()
      setOwnerDetails(
        response?.data?.docs?.map(item => ({
          value: item?.id,
          label: item?.name
        }))
      )
    }
    fetchUser()
  }, [token])

  useEffect(() => {
    const fetchBusinessLines = async () => {
      try {
        const url = `${API_URL}business-lines?limit=100`
        const res = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        })
        const result = await res.json()
        setBusinessLineList(result.data.docs)
      } catch (error) {
        console.error(error)
      }
    }

    fetchBusinessLines()
  }, [token])

  // CSV helpers (quote fields and escape internal double-quotes)
  const quote = value => {
    if (value === null || value === undefined) return '""'
    const str = String(value)
    return `"${str.replace(/"/g, '""')}"`
  }

  // header labels used in CSV in desired order
  const csvHeaderLabels = [
    'Area',
    'Lead Id',
    'Business Line',
    'Product Line',
    'Model Name',
    'Part Code',
    'Quantity',
    'Value',
    'Customer Name',
    'Executive Name',
    'Stage',
    'Lead Status'
  ]

  // fetch report on demand and download as CSV (single API call when button is clicked)
  const downloadLeadsReport = async () => {
    try {
      setPageLoader(true)

      // Call the same API that was used previously, but only now (on click)
      const url = `${API_URL}leads/report?startDate=2025-01-01&endDate=2025-12-31&pagination=false`
      const res = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'Application/Json',
          Authorization: `Bearer ${token}`
        }
      })
      const response = await res.json()

      if (response.error === false) {
        const data = response?.data?.reportData || []
        // keep in state if you want to reuse without re-fetch
        setReportData(data)

        // Build header row (quote headers too)
        const headerRow = csvHeaderLabels.map(h => quote(h)).join(',')

        // Build data rows
        const csvLines = data.map(item => {
          const rowObj = {
            Area: Array.isArray(item?.businessArea)
              ? item.businessArea.join(', ')
              : item?.businessArea ?? '',
            'Lead Id': item?.leadId ?? '',
            'Business Line': item?.businessLine ?? '',
            'Product Line': item?.productLine ?? '',
            'Model Name': item?.modelName ?? '',
            'Part Code': item?.partCode ?? '',
            Quantity: item?.quantity ?? '',
            Value: item?.value ?? '',
            'Customer Name': item?.customerName ?? '',
            'Executive Name': item?.executiveName ?? '',
            Stage: item?.stage ?? '',
            'Lead Status': item?.leadStatus ?? ''
          }

          // Ensure ordering matches csvHeaderLabels
          const values = csvHeaderLabels.map(h => quote(rowObj[h]))
          return values.join(',')
        })

        const csvContent = [headerRow, ...csvLines].join('\r\n')

        // create blob and download - filename uses date-range for clarity
        const filename = `leads_report_2025-01-01_to_2025-12-31.csv`
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        const urlBlob = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = urlBlob
        a.download = filename
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(urlBlob)
      } else {
        // API returned an error flag
        console.error('Report API error', response)
        alert('Failed to fetch report for download.')
      }
    } catch (err) {
      console.error(err)
      alert('Failed to download report. Check console for details.')
    } finally {
      setPageLoader(false)
    }
  }

  return (
    <Fragment>
      <div className='w-100'>
        <PageHeader
          pageName='VIEW LEADS'
          breadcrump1='Home'
          breadcrump2='View Leads'
          link='/dashboard'
        />
        <div className='main lg:p-6 xl:p-6 2xl:p-6 sm:p-3 md:p-3 '>
          <CardBody className='bg-white p-3'>
            <form>
              <Row>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <div>
                    <input
                      className='form-control'
                      type='text'
                      onChange={e => setSearchLead(e.target.value)}
                      placeholder='Search Here'
                    />
                  </div>
                </Col>
                <Col
                  lg={9}
                  md={9}
                  sm={6}
                  xs={6}
                  className='flex-wrap d-none d-md-block'
                >
                  <div className='lg:float-right xl:float-right 2xl:float-right flex'>
                    {userDetails.role === 'executive' ? (
                      <div>
                        <Link to='/lead'>
                          <button
                            type='button'
                            className='btn add-btn text-white mr-2'
                          >
                            +Add Lead
                          </button>
                        </Link>
                      </div>
                    ) : (
                      <>
                        <div>
                          <button
                            type='button'
                            onClick={() => setShowFilterCanvas(true)}
                            className='btn filter-btn mr-2 text-white'
                          >
                            <FontAwesomeIcon className='mr-3' icon={faList} />{' '}
                            Filters
                          </button>
                        </div>
                        <div>
                          <button
                            type='button'
                            onClick={downloadLeadsReport}
                            className='btn add-btn mr-2 text-white'
                          >
                            <FontAwesomeIcon
                              className='mr-3'
                              icon={faDownload}
                            />{' '}
                            Download
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </form>
          </CardBody>
          <CardBody>
            <div className='table-responsive w-full  mb-3 '>
              <Table hover className='align-middle table-nowrap'>
                <thead className='table-light'>
                  <tr>
                    <th>
                      <div className='flex items-center'>Opportunity ID</div>
                    </th>
                    <th>
                      <div className='flex items-center'>Name</div>
                    </th>
                    <th>
                      <div className='flex items-center'>Client Name</div>
                    </th>
                    <th>
                      <div className='flex items-center'>Value</div>
                    </th>
                    <th>
                      <div className='flex items-center'>Business Line</div>
                    </th>
                    <th>
                      <div className='flex items-center'>Expt Closure</div>
                    </th>
                    <th>
                      <div className='flex items-center'>Owner</div>
                    </th>
                    <th>
                      <div className='flex items-center'>Status</div>
                    </th>
                    {userDetails.role === 'admin' ||
                      userDetails.role === 'super_admin' ||
                      userDetails.role === 'manager' ||
                      userDetails.role === 'executive' ? (
                      <th colSpan='2'>Action</th>
                    ) : (
                      ''
                    )}
                  </tr>
                </thead>

                <tbody>
                  {pageLoader && <PageLoader />}
                  {leadList.map((data, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          {userDetails.role === 'manager' ||
                            userDetails.role === 'executive' ? (
                            <Link
                              to={
                                data.agreement.stage === 'LOST' ||
                                  data.agreement.stage === 'WON' ||
                                  data.agreement.stage === 'DROP' ||
                                  data.agreement.stage === 'won' ||
                                  data.buyingPlatform.stage === 'LOST' ||
                                  data.buyingPlatform.stage === 'DROP' ||
                                  data.agreement.stage === 'TERMINATED'
                                  ? `/lead_details/${data.id}`
                                  : `/leads/${data.id}`
                              }
                              className='text-dark no-underline'
                              onClick={() => addDealToRedux(data)}
                            >
                              {data.leadId}
                            </Link>
                          ) : (
                            <Fragment>
                              <Link
                                className='text-dark no-underline'
                                to={`/lead_details/${data.id}`}
                              >
                                {data.leadId}
                              </Link>
                            </Fragment>
                          )}
                        </td>
                        <td>{data?.leadJourneyName}</td>
                        <td>{data?.client?.companyName}</td>
                        <td>
                          {data?.productRequirements?.proposedDealAmount?.toLocaleString(
                            'en-US',
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            }
                          )}
                        </td>

                        <td>{data?.businessLine?.name}</td>
                        <td>
                          {new Date(
                            data?.enquiryDetails?.tentativeClosureDate
                          ).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric'
                          }) === 'Invalid Date'
                            ? '-'
                            : new Date(
                              data?.enquiryDetails?.tentativeClosureDate
                            ).toLocaleDateString('en-GB', {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric'
                            })}
                        </td>
                        <td>{data?.leadOwner?.name}</td>
                        <td>
                          <span
                            className={
                              data?.buyingPlatform?.stage === 'LOST' ||
                                data?.buyingPlatform?.stage === 'DROP' ||
                                data.buyingPlatform.stage === 'TERMINATED'
                                ? 'text-red-600'
                                : data?.buyingPlatform?.stage === 'WON'
                                  ? 'text-green-500'
                                  : 'text-blue-600'
                            }
                          >
                            {(data.buyingPlatform.stage === 'TERMINATED'
                              ? 'TERMINATED'
                              : data?.client === null
                                ? 'Client'
                                : data?.productRequirements?.status === 'pending'
                                  ? 'Product'
                                  : data?.enquiryDetails?.status === 'pending'
                                    ? 'Enquiry'
                                    : data?.marketingPlatform?.status === 'pending'
                                      ? 'Marketing'
                                      : data?.workingPlatform?.status === 'pending'
                                        ? 'Working'
                                        : data?.buyingPlatform?.status === 'pending'
                                          ? 'Buying'
                                          : data?.buyingPlatform?.stage
                            ).toUpperCase()}
                          </span>
                        </td>
                        {userDetails.role === 'admin' ||
                          userDetails.role === 'super_admin' ||
                          userDetails.role === 'manager' ||
                          userDetails.role === 'executive' ? (
                          <>
                            <td>
                              <Link
                                to='#'
                                className='text-warning no-underline'
                              >
                                <FontAwesomeIcon
                                  className='ml-1'
                                  onClick={() => {
                                    // Open the Change Lead Name modal and pre-fill the current name
                                    setLeadId(data?.id)
                                    setLeadJourneyName(
                                      data?.leadJourneyName || ''
                                    )
                                    setChangeLeadNameModal(true)
                                  }}
                                  icon={faPenToSquare}
                                />
                              </Link>
                            </td>
                            <td>
                              <span className='action-column'>
                                <div>
                                  <Link
                                    to='#'
                                    className='text-dark no-underline'
                                  >
                                    <FontAwesomeIcon
                                      className='ml-1'
                                      onClick={() => handleAssignLead(data?.id)}
                                      icon={faPlus}
                                    />
                                  </Link>
                                </div>
                              </span>
                            </td>
                          </>
                        ) : (
                          ''
                        )}
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
          </CardBody>
          <CardBody className='d-flex justify-content-center'>
            <nav aria-label='Leads pagination'>
              <ul className='pagination pagination-sm mb-0 flex-wrap gap-1'>
                {/* Previous button */}
                <li className={`page-item ${pageNumber <= 1 ? 'disabled' : ''}`}>
                  <Link
                    to='#'
                    className='page-link'
                    onClick={() => pageNumber > 1 && setPageNumber(pageNumber - 1)}
                  >
                    &laquo;
                  </Link>
                </li>

                {/* Page number buttons with smart ellipsis */}
                {(() => {
                  const pages = []
                  const delta = 2 // pages to show around current

                  const addPage = (num) =>
                    pages.push(
                      <li
                        key={num}
                        className={`page-item ${pageNumber === num ? 'active' : ''}`}
                      >
                        <Link
                          to='#'
                          className='page-link'
                          onClick={() => setPageNumber(num)}
                        >
                          {num}
                        </Link>
                      </li>
                    )

                  const addEllipsis = (key) =>
                    pages.push(
                      <li key={key} className='page-item disabled'>
                        <span className='page-link'>…</span>
                      </li>
                    )

                  if (totalPages <= 7) {
                    // Show all pages if total is small
                    for (let i = 1; i <= totalPages; i++) addPage(i)
                  } else {
                    addPage(1)
                    if (pageNumber - delta > 2) addEllipsis('start-ellipsis')
                    for (
                      let i = Math.max(2, pageNumber - delta);
                      i <= Math.min(totalPages - 1, pageNumber + delta);
                      i++
                    ) {
                      addPage(i)
                    }
                    if (pageNumber + delta < totalPages - 1) addEllipsis('end-ellipsis')
                    addPage(totalPages)
                  }

                  return pages
                })()}

                {/* Next button */}
                <li className={`page-item ${pageNumber >= totalPages ? 'disabled' : ''}`}>
                  <Link
                    to='#'
                    className='page-link'
                    onClick={() => pageNumber < totalPages && setPageNumber(pageNumber + 1)}
                  >
                    &raquo;
                  </Link>
                </li>
              </ul>
            </nav>
          </CardBody>
        </div>
        <Offcanvas
          direction='end'
          isOpen={showFilterCanvas}
          id='offcanvasExample'
          toggle={closeFilterCanvas}
        >
          <OffcanvasHeader className='bg-light' toggle={closeFilterCanvas}>
            Leads Fliters
          </OffcanvasHeader>
          <form
            action=''
            className='d-flex flex-column justify-content-end h-100'
          >
            <OffcanvasBody>
              <div className='mb-4'>
                <Label
                  htmlFor='datepicker-range'
                  className='form-label text-muted text-uppercase fw-semibold mb-3'
                >
                  Owner
                </Label>
                <Select
                  options={ownerDetails}
                  onChange={e => setLeadOwner(e.value)}
                  className='mb-0'
                  id='country-select'
                ></Select>
              </div>
              <div className='mb-4'>
                <Label
                  htmlFor='country-select'
                  className='form-label text-muted text-uppercase fw-semibold mb-3'
                >
                  Client
                </Label>

                <Select
                  options={clientDetails}
                  onChange={e => setClientId(e.value)}
                  className='mb-0'
                  id='country-select'
                ></Select>
              </div>
              <div className='mb-4'>
                <Label
                  htmlFor='status-select'
                  className='form-label text-muted text-uppercase fw-semibold mb-3'
                >
                  Status
                </Label>
                <Row className='g-2'>
                  <Col lg={6}>
                    <div className='form-check'>
                      <Input
                        className='form-check-input'
                        type='checkbox'
                        name='checkbox1'
                        value='won'
                        onChange={handleFilteredStage}
                      />
                      <Label
                        className='form-check-label'
                        htmlFor='inlineCheckbox1'
                      >
                        WON
                      </Label>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className='form-check'>
                      <Input
                        className='form-check-input'
                        type='checkbox'
                        name='checkbox1'
                        value='partial won'
                        onChange={handleFilteredStage}
                      />
                      <Label
                        className='form-check-label'
                        htmlFor='inlineCheckbox2'
                      >
                        PARTIAL WON
                      </Label>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className='form-check'>
                      <Input
                        className='form-check-input'
                        type='checkbox'
                        name='checkbox1'
                        value='lost'
                        onChange={handleFilteredStage}
                      />
                      <Label
                        className='form-check-label'
                        htmlFor='inlineCheckbox3'
                      >
                        LOST
                      </Label>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className='form-check'>
                      <Input
                        className='form-check-input'
                        type='checkbox'
                        name='checkbox1'
                        value='drop'
                        onChange={handleFilteredStage}
                      />
                      <Label
                        className='form-check-label'
                        htmlFor='inlineCheckbox4'
                      >
                        DROP
                      </Label>
                    </div>
                  </Col>
                </Row>
              </div>
              {
                userDetails?.role !== 'manager' ?
                  <div>
                    <Label
                      htmlFor='leads-tags'
                      className='form-label text-muted text-uppercase fw-semibold mb-3'
                    >
                      Business Lines
                    </Label>
                    <Row className='g-3'>
                      {businessLineList.map((data, index) => {
                        return (
                          <Col lg={6} key={index}>
                            <div className='form-check'>
                              <Input
                                className='form-check-input'
                                name='checkbox1'
                                type='checkbox'
                                value={data?.id}
                                onChange={handleFilteredBusinessLine}
                              />
                              <Label
                                className='form-check-label'
                                htmlFor='marketing'
                              >
                                {data?.name}
                              </Label>
                            </div>
                          </Col>
                        )
                      })}
                    </Row>
                  </div> : ''
              }

            </OffcanvasBody>
          </form>
        </Offcanvas>

        {/* Change Owner Modal (unchanged) */}
        <Modal
          show={changeLeadOwnerModal}
          onHide={() => setChangeLeadOwnerModal(false)}
          centered
        >
          <Modal.Header className='bg-indigo-200' closeButton>
            <Modal.Title>Change Owner</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div>
              <form className='row g-3 needs-validation' noValidate>
                <div className='col-md-12'>
                  <label htmlFor='name' className='form-label'>
                    Select Executive
                  </label>
                  <Select
                    options={ownerDetails}
                    onChange={e => setNewExeId(e.value)}
                  />
                </div>
              </form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={updateLeadOwner}
              className='btn add-btn text-white'
            >
              Assign
            </button>
          </Modal.Footer>
        </Modal>

        {/* Change Lead Journey Name Modal (NEW) */}
        <Modal
          show={changeLeadNameModal}
          onHide={() => setChangeLeadNameModal(false)}
          centered
        >
          <Modal.Header className='bg-indigo-200' closeButton>
            <Modal.Title>Change Lead Journey Name</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <form
              onSubmit={updateLeadJourneyName}
              className='row g-3 needs-validation'
              noValidate
            >
              <div className='col-md-12'>
                <label htmlFor='leadName' className='form-label'>
                  Lead Journey Name
                </label>
                <input
                  type='text'
                  id='leadName'
                  className='form-control'
                  value={leadJourneyName}
                  onChange={e => setLeadJourneyName(e.target.value)}
                  required
                />
              </div>
            </form>
          </Modal.Body>

          <Modal.Footer>
            <button
              onClick={updateLeadJourneyName}
              className='btn add-btn text-white'
            >
              Save
            </button>
          </Modal.Footer>
        </Modal>

        {/* Success modal */}
        <Modal show={showSuccessModal} centered>
          <Modal.Body>
            <div className='my-8 text-center'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='w-14 shrink-0 fill-green-500 inline'
                viewBox='0 0 512 512'
              >
                <path
                  d='M383.841 171.838c-7.881-8.31-21.02-8.676-29.343-.775L221.987 296.732l-63.204-64.893c-8.005-8.213-21.13-8.393-29.35-.387-8.213 7.998-8.386 21.137-.388 29.35l77.492 79.561a20.687 20.687 0 0 0 14.869 6.275 20.744 20.744 0 0 0 14.288-5.694l147.373-139.762c8.316-7.888 8.668-21.027.774-29.344z'
                  data-original='#000000'
                />
                <path
                  d='M256 0C114.84 0 0 114.84 0 256s114.84 256 256 256 256-114.84 256-256S397.16 0 256 0zm0 470.487c-118.265 0-214.487-96.214-214.487-214.487 0-118.265 96.221-214.487 214.487-214.487 118.272 0 214.487 96.221 214.487 214.487 0 118.272-96.215 214.487-214.487 214.487z'
                  data-original='#000000'
                />
              </svg>
              <h4 className='text-xl text-gray-800 font-semibold mt-4'>
                Job Done
              </h4>
              <p className='text-sm text-gray-500 leading-relaxed mt-4'>
                Operation completed successfully!
              </p>
            </div>

            <button
              type='button'
              onClick={() => setShowSuccessModal(false)}
              className='px-5 py-2.5 w-full rounded-lg text-white text-sm border-none outline-none bg-green-500 hover:bg-green-700'
            >
              Okay
            </button>
          </Modal.Body>
        </Modal>
      </div>
    </Fragment>
  )
}

export default ViewLeads
